import script from "./UnderGraduatePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnderGraduatePage.vue?vue&type=script&lang=ts&setup=true"

import "./UnderGraduatePage.vue?vue&type=style&index=0&id=33a98653&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a98653"]])

export default __exports__